import { Separator } from './types'

export const SeparatorsNames: Record<Separator, string> = {
  '•': 'dot',
  '/': 'slash',
  '>': 'arrow',
}
